<template lang="pug">
  section.division-list
    v-card-title
      v-layout(row justify-center)
        div
          v-btn(icon, @click="$router.go(-1)")
            v-icon(color="primary", large) arrow_back
        h3(style="transform: translateX(-30px)") {{ organisationName }}
    v-card-text
      v-layout(row justify-center)
        v-btn(large color="success" @click="addDivision").mb-4
          v-icon.mr-2 add
          span Создать
      v-layout(row justify-center).pb-4
        v-flex(xs11)
          Table(
            :organisationId="id",
            :list="divisionList",
            @delete-division="submitDeleteDivision")
    DeleteDialog(
      :show="deleteDialog",
      dispatchType="division",
      @close-dialog="closeDeleteDialog",
      @delete-division="deleteDivision")
      div(slot="title") Вы действительно хотите удалить,<br><b>{{ divisionName }}</b>?
</template>

<script>
import axios from 'axios/index'
import Table from './common/Table'
import AddDivision from '../AddDivision/AddDivision'
import DeleteDialog from '../../../Common/DeleteDialog/DeleteDialog'
export default {
  name: 'DivisionList',
  components: { DeleteDialog, AddDivision, Table },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    show: false,
    divisionList: [],
    divisionId: '',
    divisionName: '',
    deleteDialog: false
  }),
  mounted() {
    this.getDivisionList()
  },
  computed: {
    organisationName() {
      return this.$store.state.organisation.organisationItem.name
    }
  },
  methods: {
    addDivision() {
      this.$router.push({ path: `/main/organisation/division/add` })
    },
    getDivisionList() {
      axios({
        method: 'GET',
        url: `/api/Division/list/${this.id}`
      }).then(response => {
        this.divisionList = response.data.result
      }).catch(error => {
        console.log(error)
      })
    },
    submitDeleteDivision(id, name) {
      this.divisionId = id
      this.divisionName = name
      this.deleteDialog = true
    },
    closeDeleteDialog() {
      this.deleteDialog = false
    },
    deleteDivision() {
      axios({
        method: 'DELETE',
        url: `/api/Division/delete/${this.divisionId}`
      }).then(response => {
        this.closeDeleteDialog()
        this.getDivisionList()
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-btn {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Division/DivisionList/DivisionList.vue